"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollLegend = exports.legendRow = exports.putScroll = exports.scroll = exports.scrollBarRow = exports.strikeTableRow = exports.scrollTableRow = exports.headerRow = exports.dataTable = exports.defaultOptionScroll = exports.quadrantWrapper = void 0;

var _util = require("../../../util");

var _scroll_thumb = _interopRequireDefault(require("../../../asset/scroll_thumb.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const quadrantWrapper = () => ({
  overflow: 'hidden',
  position: 'relative',
  width: '44%',
  zIndex: 0
});

exports.quadrantWrapper = quadrantWrapper;

const defaultOptionScroll = () => ({
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '::-webkit-scrollbar': {
    display: 'none'
  }
});

exports.defaultOptionScroll = defaultOptionScroll;

const dataTable = () => ({
  minWidth: 598,
  overflow: 'hidden'
});

exports.dataTable = dataTable;

const headerRow = () => ({
  height: 48
});

exports.headerRow = headerRow;

const scrollTableRow = () => ({
  height: 32
});

exports.scrollTableRow = scrollTableRow;

const strikeTableRow = () => ({
  height: 32
});

exports.strikeTableRow = strikeTableRow;

const scrollBarRow = ({
  theme
}) => ({
  position: 'absolute',
  top: 48,
  width: '100%',
  background: (0, _util.color)(theme, 'background.default'),
  borderRight: "1px solid ".concat((0, _util.color)(theme, 'ui3')),
  borderBottom: "1px solid ".concat((0, _util.color)(theme, 'ui3')),
  height: 32,
  zIndex: 1
});

exports.scrollBarRow = scrollBarRow;

const scroll = () => ({
  overflow: 'auto',
  width: '100%',
  '::-webkit-scrollbar': {
    width: '5px',
    height: '16px',
    borderRadius: '8px',
    backgroundColor: '#eee'
  },
  '::-webkit-scrollbar-thumb': {
    background: 'rgb(255,255,255)',
    backgroundImage: "url(".concat(_scroll_thumb.default, ")"),
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundPosition: 'center, center',
    border: '1px solid #aaa',
    borderRadius: '8px',
    padding: '2px'
  }
});

exports.scroll = scroll;

const putScroll = () => ({
  width: '200%',
  height: 1
});

exports.putScroll = putScroll;

const legendRow = () => ({
  height: 48
});

exports.legendRow = legendRow;

const scrollLegend = () => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: 30
});

exports.scrollLegend = scrollLegend;
//# sourceMappingURL=OptionChainPutTable.style.js.map